/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// Soft UI Dashboard PRO React components
import SoftTypography from 'components/SoftTypography';

function DefaultCell({ value, suffix }) {
    return (
        <SoftTypography variant="caption" fontWeight="medium" color="text">
            {value}
            {suffix && (
                <SoftTypography
                    variant="caption"
                    fontWeight="medium"
                    color="secondary"
                >
                    &nbsp;&nbsp;{suffix}
                </SoftTypography>
            )}
        </SoftTypography>
    );
}

// Setting default values for the props of DefaultCell
DefaultCell.defaultProps = {
    suffix: '',
};

// Typechecking props for the DefaultCell
DefaultCell.propTypes = {
    value: PropTypes.string.isRequired,
    suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default DefaultCell;
